import AppOptionsIndex from "./option.vue";
import AppOptionsList from "./list/list.vue";
import AppOptionsItem from "./item/item.vue";

const routes = [
  {
    path: "/be/option",
    component: AppOptionsIndex,
    meta: {
      auth: {
        roles: "option.index",
        redirect: { name: "auth.login" },
        forbiddenRedirect: "/403"
      }
    },
    children: [
      {
        path: "",
        name: "option.index",
        component: AppOptionsList,
        meta: {
          auth: {
            roles: "option.index",
            redirect: { name: "auth.login" }
          }
        }
      },
      {
        path: "create",
        name: "option.create",
        component: AppOptionsItem,
        meta: {
          auth: {
            roles: "option.create",
            redirect: { name: "option.index" }
          }
        }
      },
      {
        path: ":id",
        name: "option.edit",
        component: AppOptionsItem,
        meta: {
          auth: {
            roles: "option.update",
            redirect: { name: "option.index" }
          }
        }
      }
    ]
  }
];

export default routes;
